// eslint:disable max-line-length
import { validationHighlights } from 'app/area/administration/shared/helpers';
import { CodetableTranslation } from 'app/area/codetable/constants';
import {
  shouldRenderDetails, shouldRenderTranslations
} from 'app/area/codetable/item/codetable-item-form-render-helpers';
import { ScreenField, ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { CodeEditSectionType, MetroLineConfigurationPayload } from 'app/area/codetable/item/types';
import { CodeFieldFlagWireKey, CodeFieldWireKey, CodetableFeature } from 'app/area/codetable/types-store';
import { Configuration } from 'app/components/metro-line/types';
import { routeConstants } from 'app/routes/route-constants';

export const uomSetConfiguration = ({ metadata, breadcrumbs, codeId, actionType, validationErrors,
  detailsSectionRef, substanceLinksSectionRef, translationsSectionRef
}: MetroLineConfigurationPayload):
  Configuration<CodeEditSectionType>[] => ([
    {
      section: CodeEditSectionType.SubstanceLinks,
      visible: true,
      iconUrl: '/i/case-sections/where-and-what.svg',
      url: routeConstants.codetableAdministrationCodeSectionFor(breadcrumbs, codeId, CodeEditSectionType.SubstanceLinks, actionType),
      label: (translation: CodetableTranslation) => translation.uom_sets_substance_links,
      ref: substanceLinksSectionRef,
      isValid: true
    },
    {
      section: CodeEditSectionType.Details,
      visible: shouldRenderDetails(metadata),
      iconUrl: '/i/case-sections/default.svg',
      url: routeConstants.codetableAdministrationCodeSectionFor(breadcrumbs, codeId, CodeEditSectionType.Details, actionType),
      label: (translation: CodetableTranslation) => translation.details,
      ref: detailsSectionRef,
      isValid: validationHighlights([CodeFieldFlagWireKey.scoreCalcWeight, CodeFieldFlagWireKey.disabled,
      CodetableFeature.parent, CodetableFeature.node, CodetableFeature.category, CodetableFeature.icon, CodeFieldWireKey.colourCode,
      ScreenPicker.likelihood, ScreenPicker.recurrence, ScreenPicker.severity, ScreenField.scoreCalcWeight,
      ScreenField.companyRegisterId], validationErrors)
    },
    {
      section: CodeEditSectionType.Translations,
      visible: shouldRenderTranslations(metadata),
      url: routeConstants.codetableAdministrationCodeSectionFor(breadcrumbs, codeId, CodeEditSectionType.Translations, actionType),
      iconUrl: '/i/case-sections/actions.svg',
      label: (translation: CodetableTranslation) => translation.descriptions_and_translations,
      ref: translationsSectionRef,
      isValid: validationHighlights(['language'], validationErrors)
    }
  ]);
